import React from "react";

function Gdpr() {
  return (
    <div className="add">
      <div className="content">
        {" "}
        <h1
          style={{
            padding: "20px",
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          Information om behandling av personuppgifter
        </h1>
        <div className="containerTextBorder">
          <p>
            Denna policy beskriver hur Stiftelsen Apotekare Hedbergs fond för
            medicinsk forskning, org.nr 845003-3173, (”Stiftelsen Hedberg”) och
            Bertil och Ebon Norlins stiftelse för medicinsk forskning, org.nr.
            802480-2954, (”Norlins Stiftelse”) behandlar/hanterar
            personuppgifter som erhålls inom ramen för stiftelsernas verksamhet.
            Policyn avser behandling av personuppgifter som tillhör
            anslagsansökande, prefekter och eventuella medsökande. <br />
            Denna hemsida drivs av Stiftelsen Hedberg, men ansökan genom
            hemsidan kan göras till både Stiftelsen Hedberg och Norlins
            Stiftelse. Det är den stiftelse som tar emot en ansökan som är
            personuppgiftsansvarig för de personuppgifter som lämnats in i
            ansökan. Efter att en digital ansökan lämnats in ska den sökande
            även skicka in ansökan (ej bilagorna), signerad av sökanden och
            prefekten för institutionen, per e-post till
            sara.eilert2024@gmail.com.
            <br /> Vid behov av kontakt med stiftelserna avseende support kan
            e-post skickas till support@hedbergsstiftelse.se eller brev postas
            till stiftelsernas gemensamma postadress, c/o Sara Eilert,
            Kåseholmsgatan 5, 216 22 Limhamn. För övriga frågor kontakta
            sara.eilert2024@gmail.com. <br />
            Vilka personuppgifter behandlar stiftelserna och varför är det
            nödvändigt? <br />
            De personuppgifter stiftelserna kan komma att behandla är bland
            annat namn, postadress, e postadress, telefonnummer, personnummer,
            signatur, yrkestitel, samröre med aktuella och tidigare universitet
            och institutioner (exempelvis vid inlämnande av CV) samt IP-adress.
            De flesta av nämnda personuppgifter behandlas som regel gällande den
            person som lämnar in ansökan. Gällande ansvarig prefekt behandlas
            som regel prefektens namn, yrkestitel och signatur som erhålls genom
            att ansvarig prefekt ska signera ansökan innan inlämning. Om den
            huvudsökande anger en eller flera medsökande i ansökan behandlas som
            regel personuppgifterna namn, yrkestitel och signatur för de
            medsökande.
            <br /> Beroende på den registrerades interaktion med hemsidan och
            stiftelserna är det nödvändigt att den registrerade tillhandahåller
            stiftelserna lämpliga personuppgifter för att hemsidan ska kunna
            bedrivas, för att kunna besvara eventuella frågor och för att
            stiftelserna ska kunna utföra sina syften genom att bland annat
            bedöma och utvärdera ansökningar samt utbetala forskningsanslag till
            legitima och utvalda projekt. Det är även nödvändigt för
            stiftelserna att kunna identifiera om två eller flera personer
            exempelvis lämnar in varsin ansökan för samma gemensamma projekt
            samt att kunna identifiera om någon av den huvudsökande eller
            medsökande tidigare erhållit forskningsanslag från någon av
            stiftelserna. Detta för att kunna göra en mer informerad och rättvis
            fördelning av forskningsanslag till olika projekt och forskare. För
            det fall lämpliga personuppgifter inte tillhandahålls vid
            anslagsansökan kan stiftelserna exempelvis sakna möjlighet att på
            ett informerat sätt bedöma och utvärdera ansökan och/eller utbetala
            forskningsanslag. Det kan resultera i att den ansökande inte
            erhåller något anslag. <br />
            Ändamål och rättslig grund för behandling Stiftelserna behandlar
            personuppgifter avseende hemsidans besökare för följande ändamål;
            insamling av statistik om hemsidans användning för att förbättra
            hemsidans funktionalitet och användarvänlighet. Behandlingen grundas
            på den rättsliga grunden ”berättigat intresse” (artikel 6.1 f
            dataskyddsförordningen). Stiftelserna har ett berättigat intresse
            att behandla personuppgifter på angivet sätt då det är en
            förutsättning för att bedriva och tillhandahålla en tillgänglig och
            användarvänlig hemsida med information om stiftelserna och dess
            verksamhet samt med en portal för att lämna in anslagsansökningar.
            Stiftelserna behandlar personuppgifter avseende ansökande, prefekter
            och eventuella medsökande för följande ändamål; hantering och
            registrering av ansökningar om forskningsanslag, bedömning och
            utvärdering av ansökningar, beslut om tilldelning av
            forskningsanslag, utbetalning av beviljade anslag, uppföljning och
            redovisning av beviljade anslag, publicering av anslagsmottagarnas
            namn på hemsidan och statistik över utdelade anslag. Behandlingen
            grundas på den rättsliga grunden "berättigat intresse” (artikel 6.1
            f dataskyddsförordningen). Stiftelserna har ett berättigat intresse
            att behandla personuppgifter på angivet sätt då det är en
            förutsättning för att stiftelserna ska kunna fullgöra sina ändamål
            att främja medicinsk forskning genom att dela ut forskningsanslag
            till forskare och att göra detta på ett transparent sätt. Behandling
            av personuppgifterna ligger även i den registrerades intresse då
            forskare, genom behandlingen, ges möjlighet att ansöka om och
            erhålla forskningsanslag som möjliggör genomförande av viktiga
            medicinska forskningsprojekt. Personuppgifter behandlas även för att
            stiftelserna skall kunna uppfylla sina förpliktelser enligt lag.
            Sådan behandling kan grunda sig i exempelvis bokföringslagen,
            skattelagstiftningen eller annan lagstiftning. Behandlingen grundas
            på den rättsliga grunden ”rättslig förpliktelse” (artikel 6.1 c
            dataskyddsförordningen). Vem kan ta del av de behandlade
            personuppgifterna (mottagare)? De kategorier av mottagare som tar
            del av de behandlade personuppgifterna är stiftelsernas
            styrelseledamöter (båda styrelserna består av samma personer) samt
            stiftelsernas IT-konsult som bistår stiftelserna i upprätthållandet
            och drivandet av hemsidan och hanteringen av inkomna ansökningar. De
            personer som företräder IT-konsulten och som har tillgång till de
            behandlade personuppgifterna enligt denna personuppgiftspolicy är
            bundna av sekretessavtal. Därutöver sparas de personuppgifter som
            läggs in på hemsidan hos Amazon Web Services som tillhandahåller
            hemsidan. De servrar på vilka behandlade personuppgifter lagras
            finns i Sverige. Hur länge lagras personuppgifterna? Personuppgifter
            som behandlas i samband med icke beviljad ansökan lagras i tre
            månader och personuppgifter som behandlas i samband med beviljad
            ansökan lagras i tio år efter mottagandet av ansökan.
            Personuppgifter som förekommer i stiftelsernas bokföring lagras i
            sju år efter utgången av vid aktuell tidpunkt innevarande
            räkenskapsår. Dina rättigheter i förhållande till dina
            personuppgifter Som registrerad har du rätt att: ∙ begära att få
            information om vilka personuppgifter stiftelserna behandlar som rör
            dig ∙ begära rättelse eller radering av personuppgifter som rör dig
            ∙ begära begräsning av, eller invända mot, behandling av
            personuppgifter som rör dig ∙ få ut dina personuppgifter som
            behandlas av stiftelserna i ett format som möjliggör överföring av
            personuppgifterna till annan ∙ inge klagomål om stiftelsernas
            behandling av dina personuppgifter till Integritetsskyddsmyndigheten
            (IMY)
          </p>
        </div>
      </div>
    </div>
  );
}

export default Gdpr;
